export default "__VITE_ASSET__B8s2pQ6M__"